module.exports = __webpack_public_path__ + "img/talkButtonActive.9d45db9d.webp";